(ns shared.core.components.label
  (:require [shared.core.components.icon :as icon]
            [shared.core.components.tooltip :as tooltip]
            [shared.core.components.theme :as theme]
            [shared.core.style :as style]))

(def size-styles {:large {:font-size 14
                          :margin-bottom 5}})

(defn label [{:keys [class-name style required? info-tooltip size dark-style]} & contents]
  (into [theme/theme
           :div {:class-name class-name
                 :style (merge {:color (style/color :gray :base)
                                :font-size 12
                                :font-weight style/font-medium-weight
                                :display :flex
                                :align-items :center
                                :margin-bottom 3}
                               (get size-styles size)
                               style)
                 :theme (style/dark-style (merge {:color (style/dark-color :on-background :base)}
                                                 dark-style))}]
          (concat [contents]
                  (when required?
                    [[:span {:style {:margin-left 2}} "*"]])
                  (when info-tooltip
                    [[tooltip/tooltip
                      {:placement :right
                       :tooltip-content info-tooltip
                       :target-content [icon/material-icon
                                        {:icon-type :info
                                         :style {:cursor :pointer
                                                 :font-size 14
                                                 :margin-left 3}}]}]]))))

(defn primary-label [{:keys [style] :as args} & contents]
  (into [label (assoc args :style (merge {:color (style/color :on-background :base)}
                                         style))]
        contents))
